(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fe-plaque-maker"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fe-plaque-maker]').forEach(function(root){
  if(root.dataset.ready==='true') return;
  root.dataset.ready='true';
  var printArea=root.querySelector('[data-print-area]');
  var content=root.querySelector('[data-plaque-content]');
  var photoInput=root.querySelector('[data-photo-input]');
  var photoPreview=root.querySelector('[data-photo-preview]');
  var photoPlaceholder=root.querySelector('[data-photo-placeholder]');
  var dropzone=root.querySelector('[data-dropzone]');
  var centerPhotoButton=root.querySelector('[data-photo-center]');
  var fontSelect=root.querySelector('[data-font]');
  var nameSize=root.querySelector('[data-name-size]');
  var printRoot=null;
  var defaults={name:'The Johnson Family',location:'Nairobi, Kenya',ministry:'Serving with Example Missions',body:'Working with local churches to train leaders, support families and share the Gospel throughout the region.',prayer:'Pray for wisdom, health and open doors.'};
  var photoPosition={x:50,y:50};
  var panState=null;

  function clamp(value,min,max){
    return Math.min(max,Math.max(min,value));
  }

  function setPhotoPosition(x,y){
    photoPosition.x=clamp(x,0,100);
    photoPosition.y=clamp(y,0,100);
    photoPreview.style.objectPosition=photoPosition.x+'% '+photoPosition.y+'%';
  }

  function centerPhoto(){
    setPhotoPosition(50,50);
  }

  function updateField(input){
    var key=input.dataset.field;
    var target=root.querySelector('[data-preview="'+key+'"]');
    if(target) target.textContent=input.value;
  }

  root.querySelectorAll('[data-field]').forEach(function(input){
    input.addEventListener('input',function(){updateField(input);});
  });

  function useImage(file){
    if(!file||!file.type||file.type.indexOf('image/')!==0) return;
    var reader=new FileReader();
    reader.onload=function(e){
      photoPreview.src=e.target.result;
      centerPhoto();
      photoPreview.hidden=false;
      photoPreview.draggable=false;
      photoPlaceholder.hidden=true;
      dropzone.classList.add('has-photo');
      centerPhotoButton.hidden=false;
    };
    reader.readAsDataURL(file);
  }

  photoInput.addEventListener('change',function(){useImage(photoInput.files[0]);});
  ['dragenter','dragover'].forEach(function(evt){dropzone.addEventListener(evt,function(e){e.preventDefault();dropzone.classList.add('is-dragging');});});
  ['dragleave','drop'].forEach(function(evt){dropzone.addEventListener(evt,function(e){e.preventDefault();dropzone.classList.remove('is-dragging');});});
  dropzone.addEventListener('drop',function(e){useImage(e.dataTransfer.files[0]);});

  dropzone.addEventListener('pointerdown',function(e){
    if(photoPreview.hidden) return;
    if(e.pointerType==='mouse'&&e.button!==0) return;
    panState={
      pointerId:e.pointerId,
      startX:e.clientX,
      startY:e.clientY,
      originX:photoPosition.x,
      originY:photoPosition.y,
      width:Math.max(dropzone.getBoundingClientRect().width,1),
      height:Math.max(dropzone.getBoundingClientRect().height,1)
    };
    dropzone.classList.add('is-panning');
    e.preventDefault();
  });

  document.addEventListener('pointermove',function(e){
    if(!panState||e.pointerId!==panState.pointerId) return;
    var dx=((e.clientX-panState.startX)/panState.width)*100;
    var dy=((e.clientY-panState.startY)/panState.height)*100;
    setPhotoPosition(panState.originX-dx,panState.originY-dy);
    e.preventDefault();
  });

  function finishPan(e){
    if(!panState) return;
    if(e&&e.pointerId!==undefined&&e.pointerId!==panState.pointerId) return;
    panState=null;
    dropzone.classList.remove('is-panning');
  }

  document.addEventListener('pointerup',finishPan);
  document.addEventListener('pointercancel',finishPan);

  dropzone.addEventListener('keydown',function(e){
    if(photoPreview.hidden) return;
    var step=e.shiftKey?5:2;
    var x=photoPosition.x;
    var y=photoPosition.y;
    var handled=true;
    if(e.key==='ArrowLeft') x+=step;
    else if(e.key==='ArrowRight') x-=step;
    else if(e.key==='ArrowUp') y+=step;
    else if(e.key==='ArrowDown') y-=step;
    else if(e.key==='Home'){x=50;y=50;}
    else handled=false;
    if(handled){
      e.preventDefault();
      setPhotoPosition(x,y);
    }
  });

  centerPhotoButton.addEventListener('click',centerPhoto);

  fontSelect.addEventListener('change',function(){printArea.style.setProperty('--plaque-font',fontSelect.value);});
  nameSize.addEventListener('change',function(){
    var size=nameSize.value+'px';
    root.querySelector('[data-preview="name"]').style.fontSize=size;
    printArea.style.setProperty('--print-name-size',size);
  });

  function copyRenderedStyles(source,clone){
    var sourceNodes=[source].concat(Array.from(source.querySelectorAll('*')));
    var cloneNodes=[clone].concat(Array.from(clone.querySelectorAll('*')));
    sourceNodes.forEach(function(sourceNode,index){
      var cloneNode=cloneNodes[index];
      if(!cloneNode) return;
      var styles=window.getComputedStyle(sourceNode);
      for(var i=0;i<styles.length;i+=1){
        var property=styles[i];
        cloneNode.style.setProperty(property,styles.getPropertyValue(property),'important');
      }
    });
  }

  function finishPrint(){
    document.body.classList.remove('fe-plaque-print-mode');
    if(printRoot){
      printRoot.remove();
      printRoot=null;
    }
  }

  function preparePrint(){
    finishPrint();
    var rect=printArea.getBoundingClientRect();
    if(!rect.width||!rect.height) return false;

    var clone=printArea.cloneNode(true);
    copyRenderedStyles(printArea,clone);
    clone.removeAttribute('data-print-area');
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach(function(node){node.removeAttribute('id');});
    clone.style.setProperty('width',rect.width+'px','important');
    clone.style.setProperty('height',rect.height+'px','important');
    clone.style.setProperty('min-width',rect.width+'px','important');
    clone.style.setProperty('min-height',rect.height+'px','important');
    clone.style.setProperty('max-width','none','important');
    clone.style.setProperty('max-height','none','important');
    clone.style.setProperty('margin','0','important');
    clone.style.setProperty('box-shadow','none','important');

    var snapshot=document.createElement('div');
    snapshot.className='fe-print-root__snapshot';
    snapshot.style.setProperty('width',rect.width+'px','important');
    snapshot.style.setProperty('height',rect.height+'px','important');
    snapshot.appendChild(clone);

    var page=document.createElement('div');
    page.className='fe-print-root__page';
    page.appendChild(snapshot);

    printRoot=document.createElement('div');
    printRoot.className='fe-print-root';
    printRoot.setAttribute('aria-hidden','true');
    printRoot.appendChild(page);
    document.body.appendChild(printRoot);

    var letterWidth=8.5*96;
    var letterHeight=11*96;
    var scale=Math.min(letterWidth/rect.width,letterHeight/rect.height);
    snapshot.style.setProperty('transform','scale('+scale+')','important');

    document.body.classList.add('fe-plaque-print-mode');
    return true;
  }

  window.addEventListener('afterprint',finishPrint);
  window.addEventListener('beforeprint',function(){
    if(!printRoot) preparePrint();
  });

  root.querySelector('[data-print]').addEventListener('click',function(){
    if(!preparePrint()) return;
    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(function(){window.print();});
    });
  });
  root.querySelector('[data-reset]').addEventListener('click',function(){
    root.querySelectorAll('[data-field]').forEach(function(input){input.value=defaults[input.dataset.field]||'';updateField(input);});
    fontSelect.selectedIndex=0;
    nameSize.value='40';
    printArea.style.setProperty('--plaque-font',fontSelect.value);
    root.querySelector('[data-preview="name"]').style.fontSize='40px';
    printArea.style.setProperty('--print-name-size','40px');
    photoInput.value='';
    photoPreview.src='';
    photoPreview.hidden=true;
    photoPlaceholder.hidden=false;
    dropzone.classList.remove('has-photo','is-panning');
    centerPhotoButton.hidden=true;
    centerPhoto();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
